import React from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ImprintPage from './pages/ImprintPage';
import PrivacyPage from './pages/PrivacyPage';
import RevocationPage from './pages/RevocationPage';
import TermsPage from './pages/TermsPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/impressum" element={<ImprintPage />} />
        <Route path="/datenschutz" element={<PrivacyPage />} />
        <Route path="/widerrufsbelehrung" element={<RevocationPage />} />
        <Route path="/agb" element={<TermsPage />} />
      </Routes>
    </Router>
  );
}

export default App;